import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getsensor_dag, getsensor_maand, getsensor_uur } from "../Standplaatsen/Reducers/actions";
import { fetchgastenverbruikone, deleteReservering, activeerReservering, addwkhboeking, changeampere } from "./Reducers/actions";
import { fixmessage, message } from "../../Reducers/loading/actions";
import { getsensordevice_id, getsensorstatus, schakelkwhnmeter } from "../Sensors/Reducers/actions";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import BarGraph from "./Components/graphelectra";
import { Link } from "react-router-dom";
import Tabel from "./Components/tabelelectra";
import FilterSensor from "./Components/filterelect";
import Loading from "../../Components/loading/loading";

import BoekingsregelsTabel from "./Components/BoekingsRegels";
import Gastenkaart from "./Components/Gastenkaart";
import AddKWHForm from "../Standplaatsen/Kampeerplaatsen/Components/forms/addkwh";
import AddAmpereForm from "../Standplaatsen/Kampeerplaatsen/Components/forms/ampere";
const GastenVerbruikKampeer = (props) => {
  const [load, Setload] = useState(false);
  const [openmodal, Setopenmodal] = useState(false);
  const [kampeerplaatsid, Setkampeerplaatsid] = useState(null);
  const [datum_hour, Setdatum_hour] = useState({
    startdate: moment().subtract(1, "days").toDate(),
    enddate: new Date(),
  });
  const [gemiddelde, Setgemiddelde] = useState(0);
  const [stand, setStand] = useState(0);
  const [standdag, setStandDag] = useState(0);
  const [dataType, setDataType] = useState("dag"); // "dag" or "uur"

  const [max, Setmax] = useState(0);
  // Acties menu state
  const [addnewkwh, setAddnewkwh] = useState(false);
  const [ampere, setAmpere] = useState(false);
  const [showActiesMenu, setShowActiesMenu] = useState(true);
  
  const params = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    getvals()
      .then((data) => getvals_dag(data))
      .then((data) => getvals_uur(data))
      .then(() => Setload(true));
  }, []);

  function getvals() {
    return new Promise((resolve, reject) => {
      props.fetchgastenverbruikone(params.id).then((data) => {
        if (data.results) {
          resolve(data.results);
        } else {
          props.message(3000, "warning", "Er is een fout opgtreden bij het laden van de sensoren");
          reject(new Error("Er is een fout opgetreden bij het laden van de sensoren"));
        }
      });
    });
  }

  function getvals_dag(data) {
    return new Promise((resolve, reject) => {
      const aankomst = moment(data.aankomst);
      const vertrek = moment(data.vertrek).isValid() ? moment(data.vertrek) : moment();
      const verblijfsduurUren = vertrek.diff(aankomst, 'hours');
      
      // Als verblijf <= 48 uur, gebruik uur-data voor meer detail
      if (verblijfsduurUren <= 48) {
        console.log(`Verblijfsduur ${verblijfsduurUren} uur - gebruik uur-data voor meer detail`);
        setDataType("uur");
        props.getsensor_uur(data.standplaats._id, { 
          startdate: aankomst.toDate(), 
          enddate: vertrek.toDate() 
        }).then((hourData) => {
          if (!hourData.results) {
            props.message(3000, "warning", "Er is een fout opgtreden bij het laden van de sensoren");
            reject(new Error("Er is een fout opgetreden bij het laden van de sensoren"));
          } else {
            const hourValues = hourData.results.data.map((element) => element.value);
            const totalVerbruik = hourValues.reduce((a, b) => a + b, 0);
            const aantalDagen = verblijfsduurUren / 24;
            const dagGemiddelde = aantalDagen > 0 ? totalVerbruik / aantalDagen : 0;
            
            Setgemiddelde(dagGemiddelde/10);
            Setmax(Math.max(...hourValues));
            setStandDag(hourValues.reduce((acc, curr) => acc + curr, 0).toFixed(2));
            resolve(hourData.results);
          }
        });
      } else {
        // Normale dag-data voor langere verblijven
        console.log(`Verblijfsduur ${verblijfsduurUren} uur - gebruik dag-data`);
        setDataType("dag");
        props.getsensor_dag(data.standplaats._id, { 
          startdate: aankomst.toDate(), 
          enddate: vertrek.toDate() 
        }).then((dayData) => {
          if (!dayData.results) {
            props.message(3000, "warning", "Er is een fout opgtreden bij het laden van de sensoren");
            reject(new Error("Er is een fout opgetreden bij het laden van de sensoren"));
          } else {
            const dayValues = dayData.results.data.map((element) => element.value);
            Setgemiddelde(dayValues.reduce((a, b) => a + b, 0) / dayValues.length);
            Setmax(Math.max(...dayValues));
            setStandDag(dayValues.reduce((acc, curr) => acc + curr, 0).toFixed(2));
            resolve(dayData.results);
          }
        });
      }
    });
  }

  function getvals_uur(data) {
    return new Promise((resolve, reject) => {
      props.getsensor_uur(data._id, datum_hour).then((data) => {
        if (!data.results) {
          props.message(3000, "warning", "Er is een fout opgtreden bij het laden van de sensoren");
          reject(new Error("Er is een fout opgetreden bij het laden van de sensoren"));
        } else {
          if (data.results.data && data.results.data[0]) setStand(data.results.data[0].value.toFixed(2));
          resolve();
        }
      });
    });
  }

  const { kampeerplaats, gastverbruik } = props;

  const handleDeleteReservation = async () => {
    if (window.confirm("Weet je zeker dat je deze reservering wilt verwijderen?")) {
      try {
        // Navigate first to prevent render errors
        navigate("/gastenverbruik");
        const result = await props.deleteReservering(params.id);
        if (result && result.success) {
          props.message(3000, "success", "Reservering succesvol verwijderd");
        } else {
          props.message(3000, "error", "Er is een fout opgetreden bij het verwijderen");
        }
      } catch (error) {
        props.message(3000, "error", "Er is een fout opgetreden bij het verwijderen");
      }
    }
  };

  const handleActivateReservation = async () => {
    if (window.confirm("Weet je zeker dat je deze reservering wilt activeren? Dit zal de sensor koppelen aan de reservering en de meterstand bij aankomst instellen.")) {
      try {
        const result = await props.activeerReservering(params.id);
        if (result && result.success) {
          props.message(3000, "success", "Reservering succesvol geactiveerd");
          // Refresh the data to show updated status
          getvals()
            .then((data) => getvals_dag(data))
            .then((data) => getvals_uur(data));
        } else {
          props.message(3000, "error", result?.errors?.global || "Er is een fout opgetreden bij het activeren");
        }
      } catch (error) {
        props.message(3000, "error", "Er is een fout opgetreden bij het activeren");
      }
    }
  };

  const handleReactivateReservation = async () => {
    if (window.confirm("Weet je zeker dat je deze reservering wilt re-activeren? Dit zal de sensor opnieuw koppelen maar de meterstand bij aankomst behouden.")) {
      try {
        const result = await props.activeerReservering(params.id);
        if (result && result.success) {
          props.message(3000, "success", "Reservering succesvol re-geactiveerd");
          // Refresh the data to show updated status
          getvals()
            .then((data) => getvals_dag(data))
            .then((data) => getvals_uur(data));
        } else {
          props.message(3000, "error", result?.errors?.global || "Er is een fout opgetreden bij het re-activeren");
        }
      } catch (error) {
        props.message(3000, "error", "Er is een fout opgetreden bij het re-activeren");
      }
    }
  };

  // Handler voor boeking afronden (net zoals in modal)
  const handleBoekingAfronden = async () => {
    if (window.confirm("Weet je zeker dat je deze boeking wilt afronden?")) {
      try {
        // Hier zou je de afronden actie moeten implementeren
        // Dit hangt af van hoe het in de modal is geïmplementeerd
        props.message(3000, "info", "Boeking afronden functionaliteit moet nog geïmplementeerd worden");
      } catch (error) {
        props.message(3000, "error", "Er is een fout opgetreden bij het afronden");
      }
    }
  };

  // Handler voor extra kWh toevoegen
  const handleSubmitAddKwh = async (values) => {
    try {
      const result = await props.addwkhboeking(gastverbruik._id, values);
      if (result && result.success) {
        props.message(3000, "success", "kWh succesvol toegevoegd");
        setAddnewkwh(false);
        // Refresh data
        getvals()
          .then((data) => getvals_dag(data))
          .then((data) => getvals_uur(data));
      } else {
        props.message(3000, "error", "Er is een fout opgetreden bij het toevoegen van kWh");
      }
    } catch (error) {
      props.message(3000, "error", "Er is een fout opgetreden bij het toevoegen van kWh");
    }
  };

  // Handler voor ampere wijzigen
  const handleSubmitChangeAmpere = async (values) => {
    try {
      const result = await props.changeampere(gastverbruik._id, values);
      if (result && result.success) {
        props.message(3000, "success", "Ampere succesvol gewijzigd");
        setAmpere(false);
        // Refresh data
        getvals()
          .then((data) => getvals_dag(data))
          .then((data) => getvals_uur(data));
      } else {
        props.message(3000, "error", "Er is een fout opgetreden bij het wijzigen van ampere");
      }
    } catch (error) {
      props.message(3000, "error", "Er is een fout opgetreden bij het wijzigen van ampere");
    }
  };

  if (load && gastverbruik && gastverbruik.standplaats) {
    return (
      <div className="box box-default show-elecra">
        <div className="box-header with-border">
          <h3 className="box-title">
            Aankomst <strong> {moment(gastverbruik.aankomst).format("D MMMM: HH:00")}</strong> voor <strong>{gastverbruik.standplaats.naam} </strong>
            Vertrek: <strong> {moment(gastverbruik.vertrek).isValid() ? moment(gastverbruik.vertrek).format("D MMMM HH:mm") : moment().format("D MMMM HH:mm")}</strong>
            {gastverbruik.status === "checkout" ? <span className="badge badge-success ">Uigechecked</span> : " "}
          </h3>
          <div className="box-tools pull-right">
            <button 
              className="btn btn-danger btn-sm" 
              onClick={handleDeleteReservation}
              title="Reservering verwijderen"
            >
              <i className="fa fa-trash" /> Verwijderen
            </button>
          </div>
        </div>
        
        <Gastenkaart gastverbruik={gastverbruik} />
        
        <div className="box box-default">
          <div className="box-header with-border">
            <FilterSensor gastverbruik={gastverbruik} verbruik={standdag} gemiddelde={gemiddelde} max={max} stand={stand} />
          </div>
        </div>

        {/* Acties Menu */}
        {gastverbruik.standplaats?.device && (
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title">
                <i className="fas fa-cog me-2"></i>Boeking acties
              </h3>
              <div className="box-tools pull-right">
                <button 
                  type="button" 
                  className="btn btn-box-tool" 
                  onClick={() => setShowActiesMenu(!showActiesMenu)}
                >
                  <i className={`fas ${showActiesMenu ? 'fa-minus' : 'fa-plus'}`}></i>
                </button>
              </div>
            </div>
            
            {showActiesMenu && (
              <div className="box-body">
                <div className="row">
                  {/* Boeking Acties Groep */}
                  <div className="col-12 mb-3">
                    <h6 className="text-muted mb-2">
                      <i className="fas fa-clipboard-list me-2"></i>Boeking acties
                    </h6>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-2">
                      <div className="col">
                        <button
                          type="button"
                          className="btn btn-sm btn-success w-100 text-white"
                          onClick={handleBoekingAfronden}
                        >
                          <i className="fas fa-check me-2"></i>
                          Boeking afronden
                        </button>
                      </div>
                      
                      {Boolean(!gastverbruik.meterstanndaankomst || gastverbruik.meterstanndaankomst === 0) && (
                        <div className="col">
                          <button 
                            className="btn btn-sm btn-primary w-100 text-white" 
                            onClick={handleActivateReservation}
                            title="Activeer reservering - koppel aan sensor en zet meterstand bij aankomst"
                          >
                            <i className="fa fa-power-off me-2" />
                            Activeer Reservering
                          </button>
                        </div>
                      )}
                      
                      {Boolean(gastverbruik.meterstanndaankomst && gastverbruik.meterstanndaankomst !== 0) && (
                        <div className="col">
                          <button 
                            className="btn btn-sm btn-warning w-100 text-white" 
                            onClick={handleReactivateReservation}
                            title="Re-activeer reservering - koppel opnieuw aan sensor maar behoud meterstand bij aankomst"
                          >
                            <i className="fa fa-refresh me-2" />
                            Re-activeer Reservering
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Meter Instellingen Groep */}
                  {gastverbruik.standplaats?.device && (
                    <div className="col-12 mb-3">
                      <h6 className="text-muted mb-2">
                        <i className="fas fa-cog me-2"></i>Meter instellingen
                      </h6>
                      <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-2">
                        <div className="col">
                          <button 
                            type="button" 
                            className="btn btn-sm btn-warning w-100 text-white" 
                            onClick={() => setAddnewkwh(!addnewkwh)}
                          >
                            <i className="fas fa-bolt me-2"></i>
                            Extra kWh
                          </button>
                        </div>

                        <div className="col">
                          <button 
                            type="button" 
                            className="btn btn-sm btn-warning w-100 text-white" 
                            onClick={() => setAmpere(!ampere)}
                          >
                            <i className="fas fa-bolt me-2"></i>
                            Ampere instellen
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                
                {/* Forms */}
                {addnewkwh && (
                  <AddKWHForm onSubmit={handleSubmitAddKwh} />
                )}
                {ampere && (
                  <AddAmpereForm 
                    onSubmit={handleSubmitChangeAmpere} 
                    ampere={gastverbruik.ampere} 
                  />
                )}
              </div>
            )}
          </div>
        )}

        <div className=" box-primary">
          <div className="box-body" />
          <div className="row p-2">
            <div className="col-12 col-md-10 col-lg-12">
              <Tabel 
                sensor={dataType === "uur" ? kampeerplaats.uur : kampeerplaats.dag} 
                gastverbruik={gastverbruik} 
              />
            </div>
            <div className="col-12">
              <BarGraph 
                sensor={dataType === "uur" ? kampeerplaats.uur : kampeerplaats.dag} 
                kleur="#B1BF41" 
                type={dataType} 
              />
              <div className="mt-2">
                <small className="text-muted">
                  {dataType === "uur" ? 
                    "📊 Gedetailleerde uurweergave (verblijf ≤ 48 uur)" : 
                    "📊 Dagweergave (verblijf > 48 uur)"
                  }
                </small>
              </div>
            </div>

            {/* <div className="col-12 col-md-12 col-lg-12">
              <div className="box-titel">
                <h3 className="p-4">Metingen 24 uur</h3>
              </div>

              <BarGraph sensor={kampeerplaats.uur} kleur="#D96A29" type="uur" />
            </div> */}
          </div>
        </div>
        <div className="box box-default">
          <div className="box-header with-border">
            <h3 className="box-title">Boekingsregels</h3>
          </div>
          <div className="box-body">
            <BoekingsregelsTabel boekingsregels={gastverbruik.boekingsregels} betalingen={gastverbruik.betaling} />
          </div>
        </div>

      </div>
    );
  } else {
    return <Loading loadings={load} />;
  }
};

function mapStateToProps(state) {
  return { sensor: state.sensoren, kampeerplaats: state.standplaatsen, gastverbruik: state.gastenverbruik.gastverbruik };
}

export default connect(mapStateToProps, { 
  fetchgastenverbruikone, 
  deleteReservering, 
  activeerReservering, 
  message, 
  fixmessage, 
  getsensor_dag, 
  getsensor_maand, 
  getsensor_uur, 
  addwkhboeking, 
  changeampere,
  getsensordevice_id,
  getsensorstatus,
  schakelkwhnmeter
})(GastenVerbruikKampeer);
